<template>
  <div>
    <b-card
      v-if="items.length > 1"
      class="mb-1 mt-1"
      no-body
    >
      <b-card-header
        class="d-flex flex-row align-items-center justify-content-between"
        :class="`bg-${items[0].variant}`"
      >
        <b-link
          class="text-gray-700 bold d-block my-0"
          :class="`text-${items[0].variant}`"
          style="text-decoration: none"
          @click="state = !state"
        >
          <font-awesome-icon
            class="mr-1"
            :icon="['fas', state ? 'square-minus' : 'square-plus']"
          />
          <span>{{ items[0].message }} + {{ items.length-1 }} errors</span>
        </b-link>
        <b-link>
          <font-awesome-icon
            class="mr-1 text-secondary"
            :icon="['fas', 'xmark']"
            @click="dismissAll"
          />
        </b-link>
      </b-card-header>

      <b-collapse id="daily-reports" :visible="state" accordion="daily-reports" role="tabpanel">
        <b-card-body>
          <b-collapse
            :visible="state"
          >
            <b-alert
              v-for="(error, i) in items"
              :key="`${i}-${items.length}`"
              :variant="error.variant"
              show
              dismissible
              @dismissed="() => { onFlushError(error) }"
            >
              <font-awesome-icon v-if="error.icon" :icon="error.icon" class="mr-2" size="lg" />
              {{ error.message }}
            </b-alert>
          </b-collapse>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-alert
      v-for="(error, i) in items"
      v-else
      :key="`${i}-${items.length}`"
      :variant="error.variant"
      show
      dismissible
      @dismissed="() => { onFlushError(error) }"
    >
      <font-awesome-icon v-if="error.icon" :icon="error.icon" class="mr-2" size="lg" />
      {{ error.message }}
    </b-alert>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'Errors',
  props: {
    items: {
      type: Array,
      default: () => ([])
    }
  },
  data: () => ({
    state: false
  }),
  methods: {
    ...mapActions({
      dismissError: 'repos/dismissError'
    }),
    onFlushError (e) {
      this.dismissError(e)
    },
    dismissAll () {
      this.items.forEach((e) => {
        this.dismissError(e)
      })
    }
  }
}
</script>

<style scoped>

</style>
